import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";
import i18n from "../../constants/i18n";
import { withLiteObserverAndTheme } from "../et3-enhanced-render";

const SelfieVerifiedIcon = withLiteObserverAndTheme(() => (
  <VerifiedUserIcon
    color="primary"
    titleAccess={i18n.get("USER_ALBUM_PICTURES")}
  />
));

export default SelfieVerifiedIcon;
